module.exports = __webpack_public_path__ + "assets/img/ICPLicense.8d812214.svg";